module.exports = __webpack_public_path__ + "static/media/r5s2.27bf35e2.jpg";